import React from 'react';
import { CloseIcon } from './Icons';
import { auth, googleProvider } from '../firebase';
import { signInWithPopup, signOut } from 'firebase/auth';

const Logo = () => (
  <svg 
    id="Layer_1" 
    data-name="Layer 1" 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 768 241.09" 
    className="h-[45px] sm:h-[55px] w-auto mx-auto object-contain"
    style={{ overflow: 'visible' }}
  >
    <defs>
      <style>{`
        .logo-txt-1 {
          font-family: 'Cormorant Garamond', serif;
          font-size: 52.67px;
          fill: currentColor;
          letter-spacing: 0.1em;
        }
        .logo-txt-2 {
          font-family: 'Louis George Cafe', sans-serif;
          font-size: 25px;
          font-weight: 500;
          fill: currentColor;
          opacity: 0.9;
          letter-spacing: 0.28em;
        }
        .logo-path {
          fill: currentColor;
        }
        .logo-line {
          fill: none;
          stroke: currentColor;
          stroke-miterlimit: 10;
        }
      `}</style>
    </defs>
    <g id="xzLYyD">
      <path className="logo-path" d="m391.52,18.42c1.98-2.15,4.48-3.02,7.29-3.03,1.4,0,2.68.68,3.99,1.18,1.72.65,3.03,1.89,4.39,3.05.27.23.28.46.08.77-1.98,3.09-4.78,4.91-8.4,5.38-1.76.23-3.47-.15-5.02-1.06-1.64-.97-1.67-.97-1.68.89-.02,3.03-.36,6.03-.9,9-.45,2.45-1.47,4.71-2.39,7.01-1.02,2.55-2.34,4.98-3.09,7.63-.55,1.93-1.17,3.84-1.54,5.82-.04.22-.08.44-.02.66.08.31.24.41.53.2,3.11-2.2,6.28-1.52,9.39-.09,1.65.76,3.2,1.72,4.48,3.06.24.25.34.36.09.69-1.95,2.67-4.57,4.32-7.78,4.91-2.28.42-4.46.1-6.24-1.62-.16-.16-.3-.49-.58-.35-.28.13-.1.44-.1.67-.03,1.16.51,2.19.83,3.26,1.18,3.85,3.29,7.18,5.89,10.21.35.41.26.66-.08.89-2.79,1.89-5.74,3.28-9.23,2.66-1.1-.2-2.19-.65-3.1-1.3-1.5-1.07-2.92-2.26-3.76-3.97-.24-.48-.45-.23-.63.03-.54.81-1.26,1.44-1.93,2.12-1.51,1.54-3.4,2.46-5.44,2.95-1.7.41-3.5.46-5.21-.24-1.27-.52-2.56-1.01-3.68-1.83-.83-.61-.85-.73-.18-1.49,1.34-1.54,2.64-3.11,3.92-4.7,1.13-1.41,1.72-3.02,2.21-4.69.4-1.36.85-2.71,1.03-4.13.03-.26.19-.6-.06-.76-.27-.18-.46.19-.69.29-.02,0-.04.03-.06.04-2.29,2.34-5.04,2.2-7.88,1.43-2.56-.69-4.57-2.21-6.17-4.3-.37-.48-.29-.8.1-1.2,1.4-1.44,3.14-2.34,4.92-3.18,1.4-.66,2.88-.92,4.42-.92,1.56,0,3,.37,4.25,1.36.18.14.37.42.63.24.26-.18.18-.5.12-.75-.88-3.72-1.81-7.41-3.19-11-1.16-3.01-2.17-6.09-2.88-9.26-.73-3.27-.88-6.56-.83-9.88,0-.12.02-.25,0-.37-.05-.25.15-.6-.15-.73-.24-.11-.43.17-.64.29-3.99,2.41-8.13,1.76-11.89-.99-1.02-.75-1.84-1.69-2.58-2.71-.23-.32-.22-.46.02-.72,1.34-1.48,2.97-2.54,4.79-3.33,1.38-.6,2.77-1.2,4.28-1.2,2.49,0,4.73.73,6.45,2.63.49.53.6.14.69-.22.53-1.98,1.28-3.87,2.23-5.68,2.32-4.42,5.07-8.45,9.74-10.72,1.33-.65,2.72-1.12,4.19-1.31,1.13-.14,2.19.29,3.21.64,2.17.76,3.9,2.2,5.5,3.85,2.1,2.17,3.87,4.59,5.4,7.17,1.1,1.85,1.99,3.83,2.59,5.92.08.29.14.61.32.81Zm-2.31,15.08c.02-.22-.11-.3-.22-.4-.31-.27-.64-.53-.95-.82-4.01-3.78-7.99-7.59-12.02-11.34-1.49-1.39-1.06-1.47-2.71,0-2.04,1.84-4.01,3.78-6.07,5.6-2.37,2.11-4.56,4.41-7.03,6.41-.42.34-.47.62-.05,1.01.49.45.91.98,1.41,1.4,4.21,3.55,8.09,7.47,12.32,11.01.61.51.92.39,1.45-.04,2.41-1.95,4.54-4.21,6.91-6.2,2.38-1.99,4.38-4.39,6.74-6.4.09-.08.16-.18.21-.24Zm-22.89,25.4c.07.64,0,1.23.09,1.82.17,1.07.57,2.08.84,3.12.97,3.72,2.97,6.54,6.66,7.95.32.12.6.15.91,0,3.05-1.45,5.08-3.78,6.03-7.03.23-.77.36-1.58.66-2.31.41-1,.48-2.04.61-3.08.31-2.55-.3-4.92-1.48-7.17-.31-.59-.75-1.01-1.28-1.39-2.15-1.51-4.49-2.03-7.05-1.43-1.58.37-2.99,1.01-4,2.4-1.55,2.16-1.94,4.61-2,7.12Zm9.04-41.04c2.81-.17,5.37-1.08,7.68-2.76,1.54-1.12,2.63-2.61,3.71-4.13.16-.23.02-.35-.09-.51-1.74-2.62-3.87-4.9-6.23-6.95-3.28-2.84-7.78-3.17-11.24-.33-1.02.84-2.02,1.72-2.99,2.62-1.41,1.31-2.51,2.89-3.5,4.53-.17.28-.28.55,0,.87.57.64,1.09,1.34,1.66,1.97,2.94,3.26,6.64,4.76,11.01,4.69Zm15.63,8.61c-.1-1.97-.14-4.28-.53-6.56-.42-2.47-1.41-4.74-2.45-6.99-.38-.82-.41-.84-.97-.13-2.17,2.76-5,4.52-8.27,5.66-.67.23-1.38.35-2.05.56-.59.18-.63.41-.2.8,3.99,3.61,7.89,7.32,11.71,11.11.45.45.93.88,1.4,1.3.2.18.45.43.7.34.3-.1.33-.46.35-.76.13-1.67.3-3.33.3-5.34Zm-32.61-.24c-.07,2.02.17,3.84.43,5.67.04.32.1.68.52.3,2-1.82,4-3.64,5.98-5.47,1.48-1.37,2.94-2.76,4.42-4.13,1.01-.93,2.06-1.82,3.08-2.74.26-.24.69-.61-.02-.77-1.94-.43-3.72-1.23-5.47-2.12-1.93-.98-3.58-2.32-4.79-4.15-.15-.23-.18-.64-.57-.59-.32.05-.42.38-.54.65-.67,1.47-1.16,3.02-1.68,4.55-.99,2.89-1.49,5.89-1.38,8.8Zm24.88,53.06c1.88.21,3.8-.56,5.53-1.97.46-.37.42-.62.1-1.02-1.95-2.46-3.34-5.26-4.73-8.05-.59-1.19-.83-2.5-.99-3.81-.03-.26-.07-.54-.32-.61-.26-.07-.33.24-.41.43-.19.43-.36.86-.55,1.29-.81,1.88-1.73,3.68-3.27,5.1-1.01.93-2.12,1.66-3.36,2.21-.4.18-.61.34-.21.79.52.59.93,1.27,1.43,1.87,1.69,2,3.62,3.6,6.78,3.76Zm-18.81-.07c2.07.08,3.77-.55,5.34-1.68,1.3-.94,2.24-2.19,3.22-3.42.67-.86.68-.96-.28-1.5-.24-.13-.49-.24-.72-.36-1.44-.76-2.66-1.77-3.52-3.17-.83-1.34-1.66-2.67-2.18-4.17-.07-.22-.11-.55-.42-.52-.26.03-.22.33-.28.54-.22.88-.37,1.79-.71,2.62-1.41,3.45-3.4,6.52-6.1,9.11-.24.23-.39.4-.03.62,1.81,1.06,3.61,2.11,5.7,1.94Zm-4.84-43.89c1.72,6.43,4,12.7,5.95,19.07.24-.36.35-.71.49-1.04.75-1.77,1.86-3.24,3.57-4.16.99-.53,2.09-.82,3.19-1.07.25-.06.57-.11.66-.41.09-.31-.18-.49-.39-.65-1.99-1.57-3.8-3.34-5.68-5.04-2.42-2.19-4.97-4.25-7.27-6.57-.1-.1-.18-.25-.52-.13Zm30.33-.77c-.39-.03-.6.19-.8.4-1.95,2.09-3.98,4.09-6.11,5.98-2.15,1.91-4.29,3.84-6.42,5.77-.33.3-1.05.43-.96.9.1.53.8.56,1.29.7,1.85.53,3.44,1.42,4.54,3.06.48.72.89,1.47,1.23,2.26.06.15.12.37.32.35.25-.02.24-.27.27-.46.05-.34.01-.67.13-1.02.57-1.62,1.33-3.17,1.93-4.78,1.28-3.42,2.79-6.75,3.72-10.29.25-.96.73-1.85.85-2.87Zm9.04-17.94c-3.1,0-5.05.51-6.4,2.41-.86,1.21-.7,2.72.42,3.75,2.05,1.89,4.49,2.18,7.08,1.63,2.25-.48,3.97-1.83,5.43-3.56.42-.5.41-.86-.1-1.29-2.13-1.79-4.47-3.01-6.42-2.94Zm-47.21.02c-3.37-.08-5.77,1.34-8.01,3.13-.39.31-.38.63-.04,1,2.47,2.7,5.46,4.12,9.17,3.72,1.42-.15,2.7-.68,3.69-1.79.91-1.02,1.24-2.78-.06-4.03-1.45-1.39-3.1-2.12-4.75-2.03Zm7.23,46.63c2.16.08,3.88-.71,5.11-2.52.24-.36.35-.75.35-1.18-.01-1.57-1.53-3.33-3.28-3.72-2.35-.52-4.58-.05-6.75.89-1.13.49-2.22,1.05-3.01,2.05-.28.36-.27.59.04.94,2.02,2.26,4.52,3.47,7.54,3.54Zm30.7,0c.61-.04,1.22.02,1.83-.1,2.36-.45,4.14-1.8,5.67-3.57.25-.29.14-.44-.1-.66-2.18-1.9-4.72-2.95-7.59-3.22-2.64-.25-4.66.94-5.42,3.19-.14.42-.18.83.03,1.22.47.87,1.05,1.65,1.86,2.25,1.12.83,2.4.91,3.72.88Z" />
    </g>
    <text className="logo-txt-1" transform="translate(0 167.87)">HOUSE OF KARNNIKARAA</text>
    <text className="logo-txt-2" transform="translate(167.89 230.19)">925 SILVER JEWELLERY</text>
    <line className="logo-line" x1="604.09" y1="221.96" x2="740.98" y2="221.96"/>
    <line className="logo-line" x1="11.21" y1="221.96" x2="148.09" y2="221.96"/>
  </svg>
);

const isFirebaseConfigured = () => {
  try {
    const config = auth?.app?.options;
    return config && config.apiKey && config.apiKey !== "YOUR_API_KEY";
  } catch (e) {
    return false;
  }
};

/* ── Google wordmark icon ───────────────────────────────────────── */
const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
  </svg>
);

const AuthModal = ({ isOpen, onClose, currentUser, setCurrentUser }) => {
  if (!isOpen) return null;

  const handleGoogleLogin = async () => {
    if (isFirebaseConfigured()) {
      try {
        const result = await signInWithPopup(auth, googleProvider);
        if (setCurrentUser) {
          setCurrentUser(result.user);
          localStorage.setItem('hok_currentUser', JSON.stringify({
            uid: result.user.uid,
            displayName: result.user.displayName,
            email: result.user.email,
            photoURL: result.user.photoURL,
          }));
        }
        onClose();
      } catch (error) {
        console.error("Google Sign-In Error:", error);
        alert("Google Sign-In failed: " + error.message);
      }
    } else {
      const mockUser = {
        uid: 'mock-google-user',
        displayName: 'Aman Sharma',
        email: 'amans@example.com',
        photoURL: 'https://lh3.googleusercontent.com/a/default-user'
      };
      if (setCurrentUser) {
        setCurrentUser(mockUser);
        localStorage.setItem('hok_currentUser', JSON.stringify(mockUser));
      }
      alert("ℹ️ Firebase credentials are not set. Logging in with a mock Google user account for preview.");
      onClose();
    }
  };

  const handleSignOut = async () => {
    if (isFirebaseConfigured()) {
      try {
        await signOut(auth);
      } catch (error) {
        console.error("Sign Out Error:", error);
      }
    }
    if (setCurrentUser) {
      setCurrentUser(null);
      localStorage.removeItem('hok_currentUser');
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[200] overflow-y-auto flex items-start sm:items-center justify-center p-4 sm:p-6">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-[#2a1f14]/60 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Card */}
      <div className="relative my-auto w-full max-w-[400px] bg-[#FAF6F0] shadow-2xl overflow-hidden animate-[fadeSlideUp_0.25s_ease-out] z-10 border border-[#584738]/10">

        {/* Top accent stripe */}
        <div className="h-1 w-full bg-[#584738]" />

        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-[#584738]/50 hover:text-[#584738] transition-colors focus:outline-none z-10"
          aria-label="Close"
        >
          <CloseIcon />
        </button>

        {/* Brand mark */}
        <div className="flex items-center justify-center pt-6 sm:pt-8 pb-4 sm:pb-5 border-b border-[#584738]/8 px-6">
          <div className="text-[#584738] w-[80%] sm:w-[85%] transition-transform duration-500 hover:scale-105 ease-in-out cursor-pointer">
            <Logo />
          </div>
        </div>

        <div className="px-6 sm:px-10 py-8 sm:py-10">

          {currentUser ? (
            <div className="flex flex-col items-center animate-fade-in text-center">
              <h2 className="font-serif text-[1.25rem] sm:text-[1.35rem] text-[#584738] font-normal mb-1.5">My Account</h2>
              <p className="text-[11px] font-sans font-light text-[#584738]/60 mb-5">
                Successfully signed in to House of Karnnikaraa
              </p>

              <div className="flex flex-col items-center gap-3.5 my-5 bg-white border border-[#584738]/8 p-5 w-full">
                {currentUser.photoURL ? (
                  <img src={currentUser.photoURL} alt="" className="w-14 h-14 rounded-full border border-[#584738]/15 object-cover" />
                ) : (
                  <div className="w-14 h-14 rounded-full bg-[#584738]/12 flex items-center justify-center text-[#584738] font-serif font-bold text-lg select-none">
                    {currentUser.displayName ? currentUser.displayName[0].toUpperCase() : (currentUser.email ? currentUser.email[0].toUpperCase() : 'U')}
                  </div>
                )}
                <div>
                  <p className="text-[13px] font-sans font-semibold text-[#584738]">{currentUser.displayName || 'House of Karnnikaraa Client'}</p>
                  <p className="text-[11.5px] font-sans font-light text-[#584738]/60 mt-0.5">{currentUser.email || currentUser.phone}</p>
                </div>
              </div>

              <button
                onClick={handleSignOut}
                className="w-full bg-[#584738] text-[#F5E6D8] py-3.5 text-[11px] font-sans font-medium tracking-[0.22em] uppercase hover:bg-black transition-colors focus:outline-none"
              >
                Sign Out
              </button>
            </div>
          ) : (
            <div className="flex flex-col items-center">
              <h2 className="font-serif text-[1.25rem] sm:text-[1.35rem] text-[#584738] font-normal mb-1.5">Welcome</h2>
              <p className="text-[12px] sm:text-[12.5px] font-sans font-light text-[#584738]/60 mb-6 text-center">
                Sign in with Google to view orders, write reviews, and checkout
              </p>

              <button
                className="w-full flex items-center justify-center gap-3 border border-[#584738]/15 bg-white py-3.5 px-4 text-[10.5px] font-sans font-medium uppercase tracking-[0.16em] text-[#584738] shadow-[0_1px_2px_rgba(88,71,56,0.03)] hover:bg-[#584738]/[0.02] hover:border-[#584738]/45 hover:shadow-[0_4px_12px_rgba(88,71,56,0.06)] active:scale-[0.99] transition-all duration-300 rounded-none focus:outline-none"
                onClick={handleGoogleLogin}
              >
                <span className="flex items-center justify-center w-5 h-5 flex-shrink-0">
                  <GoogleIcon />
                </span>
                <span>Continue with Google</span>
              </button>
            </div>
          )}

        </div>
      </div>

      <style>{`
        @keyframes fadeSlideUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default AuthModal;
